import styled from "styled-components"

export const ActionButtons = styled.div`
    display: flex;
    gap: 1rem;
    align-items: center;
    justify-content: flex-end;
    cursor: pointer;
`
